module.exports = __webpack_public_path__ + "static/media/app.a98375a3.png";